export default __webpack_public_path__ + "static/media/gallery.9c9e9a94.svg";